<script setup lang="ts"></script>

<template>
  <div class="bg-neon-yellow h-fit">
    <div class="px-bleed py-30 grid gap-30">
      <FormsContact />

      <hr>
      
      <FormsOnlineDemo />
      
      <hr>

      <FormsLabVisit />
    </div>

    <SiteFooter />
  </div>
</template>
